<template>
  <div class="new-community">
    <div class="data">
      <div class="header margin-bottom-medium">Podaci o zajednici</div>
      <div class="input-wrapper">
        <div class="user--mod relative">
          <label class="col-form-label col-form-label-lg"> Opština </label>
          <div
            class="ui fluid search address-search selection dropdown add-member-dropdown active visible"
          >
            <input
              class="form-control"
              rows="4"
              placeholder="Izaberite opštinu"
              ref="municipality"
              v-model.trim="municipality"
              @input="debounceInputMunicipality"
              @blur="blurInputMuni"
              @focus="municipalitySearchFocus = true"
            />

            <div
              class="menu"
              style="display: block"
              :class="{
                'list-no-border': municipalitiesFiltered.length == 0
              }"
              v-if="municipalitySearchFocus"
            >
              <div
                class="item"
                v-for="muni in municipalitiesFiltered"
                :key="muni.id"
                @click="selectMuni(muni)"
              >
                {{ muni.name }}
              </div>
            </div>
          </div>
          <!-- <model-select
            ref="municipality"
            :options="options"
            v-model="municipality"
            placeholder="
            Izaberite opštinu"
            class="muni-dropdown add-member-dropdown"
          ></model-select> -->
        </div>
      </div>

      <div class="input-wrapper">
        <div class="user--mod relative">
          <label class="col-form-label col-form-label-lg"> Ulica </label>
          <div
            class="ui fluid search address-search selection dropdown add-member-dropdown active visible"
          >
            <input
              class="form-control"
              rows="4"
              placeholder="Izaberite ulicu"
              ref="municipalityStreets"
              v-model.trim="street"
              @input="debounceInput"
              @blur="blurInput"
              @focus="addressSearchFocus = true"
            />

            <div
              class="menu"
              style="display: block"
              :class="{
                'list-no-border': municipalityStreetsFiltered.length == 0
              }"
              v-if="addressSearchFocus"
            >
              <div
                class="item"
                v-for="addr in municipalityStreetsFiltered"
                :key="addr.id"
                @click="selectAddress(addr)"
              >
                {{ addr.street_name }}{{ addr.municipality_name ? ',' : '' }}
                <span v-if="addr.municipality_name">
                  {{ addr.municipality_name }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="input-wrapper">
        <div class="user--mod relative">
          <label class="col-form-label col-form-label-lg"> Broj zgrade </label>
          <input
            ref="streetNum"
            type="text"
            class="form-control"
            placeholder=" "
            :disabled="street == null || street == ''"
            v-model="streetNumber"
            @input="handleStreetNumberInput"
          />
        </div>
      </div>
      <div class="input-wrapper">
        <div class="user--mod relative">
          <label class="col-form-label col-form-label-lg">
            Opis zajednice
          </label>
          <input
            type="text"
            class="form-control"
            placeholder=" "
            v-model="communityDescription"
          />
        </div>
      </div>
      <div
        class="data__img-input-wrapper margin-top-small margin-bottom-medium"
      >
        <picture-upload
          :height="'180px'"
          @removedUploadedImg="uploadedFile = null"
          @fileAttached="handleFileUpload"
        ></picture-upload>
      </div>
      <div class="text-center">
        <div class="user--mod relative">
          <button
            class="btn btn-primary"
            :class="{ 'is-loading': isLoading }"
            :disabled="isLoading || !isValidated"
            @click="saveCommunity"
          >
            <span v-if="!isLoading">Napravi novu zajednicu</span>
            <spinner line-fg-color="#00796b" v-if="isLoading" />
          </button>
        </div>
      </div>
    </div>
    <div class="map">
      <gmap-map
        :center="mapCenter"
        :zoom="getZoomLevel"
        @center_changed="updateCoordinates"
        map-type-id="roadmap"
        style="width: 100%; height: calc(100% - 50px)"
      >
        <gmap-marker
          v-if="streetNumber && streetNumber != ''"
          :position="mapCenter"
          :draggable="true"
          :icon="{ url: require('../assets/marker.png') }"
          @dragend="updateCoordinatesDrag"
        />
      </gmap-map>
      <!-- stara slika pina -->
      <!-- <img class="map__marker" src="@/assets/marker.png" alt /> -->
      <div v-if="streetNumber && streetNumber != ''">
        *Pomeranjem pina na mapi možete preciznije definisati lokaciju zajednice
      </div>
    </div>
  </div>
</template>

<script>
import pictureUpload from '@/components/community/PictureUploadPreview';
import axios from '@/axios/axios.js';
import { ModelSelect } from 'vue-search-select';
import { mapMutations } from 'vuex';
import { mapActions } from 'vuex';
import { UserRoles } from '@/util/UtilService.js';
import debounce from 'debounce';

export default {
  components: {
    pictureUpload
  },
  created() {
    // only super manager can access this page
    if (
      this.$store.getters.getUser.roles.indexOf(UserRoles.SUPER_MANAGER) == -1
    ) {
      this.$router.push('/notFound');
    }
    this.getAllMunicipalities();
  },
  methods: {
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations(['setCommunities', 'setActiveCommunity']),
    debounceInput: debounce(function (e) {
      this.streetNumber = '';
      this.selectedAddress = null;
      if (this.selectedMunicipality) {
        if (this.street) {
          this.municipalityStreetsFiltered = this.municipalityStreets.filter(
            (street) => {
              return street.street_name
                .toLowerCase()
                .startsWith(this.street.toLowerCase());
            }
          );
        } else {
          this.municipalityStreetsFiltered = this.municipalityStreets;
        }
      } else {
        const searchValue = e.target.value;
        if (searchValue.includes(',')) {
          this.municipalityStreetsFiltered = this.municipalityStreets.filter(
            (street) => {
              const searchString = `${street.street_name}, ${street.municipality_name}`;
              return searchString
                .toLowerCase()
                .startsWith(this.street.toLowerCase());
            }
          );
        } else {
          this.searchAddress(searchValue);
        }
      }
    }, 500),
    debounceInputMunicipality: debounce(function (e) {
      this.selectedMunicipality = null;
      this.street = '';
      this.selectedAddress = null;
      this.municipalityStreets = [];
      this.municipalityStreetsFiltered = [];
      if (this.municipality) {
        this.municipalitiesFiltered = this.municipalities.filter((muni) => {
          return muni.name
            .toLowerCase()
            .startsWith(this.municipality.toLowerCase());
        });
      } else {
        this.municipalitiesFiltered = this.municipalities;
      }
    }, 500),
    blurInput() {
      setTimeout(() => {
        this.addressSearchFocus = false;
      }, 200);
    },
    blurInputMuni() {
      setTimeout(() => {
        this.municipalitySearchFocus = false;
      }, 200);
    },
    selectMuni(muni) {
      this.selectedMunicipality = muni;
      this.street = '';
      this.selectedAddress = null;
      this.municipalityStreets = [];
      this.municipalityStreetsFiltered = [];
      this.municipality = muni.name;
      this.streetNumber = '';
      this.getLocationCoordinates(`${muni.name} ${muni.city}`);
      this.getStreetsForMunicipality(muni.id);
      this.step = 2;
      this.$nextTick(() => this.$refs.municipalityStreets.focus());
    },
    selectAddress(addr) {
      if (addr.municipality_name) {
        const muni = this.municipalities.find(
          (m) => m.id == addr.municipality_id
        );
        this.municipality = muni.name;
        this.selectedMunicipality = muni;
        this.street = `${addr.street_name},${muni.name}`;
      }
      this.street = `${addr.street_name}`;
      this.selectedAddress = addr;
      this.step = 3;
      this.streetNumber = '';

      this.getLocationCoordinates(
        addr.street_name +
          ' ' +
          this.selectedMunicipality.name +
          ' ' +
          this.selectedMunicipality.city
      );
      this.$nextTick(() => this.$refs.streetNum.focus());
    },
    async searchAddress(address) {
      if (address == '') {
        this.municipalityStreets = [];
        this.municipalityStreetsFiltered = [];
        this.streetNumber = '';
        return;
      }
      const data = {
        municipality_id: null,
        street_name: address
      };
      const response = await axios.post('address/get-by-municipality', data);
      this.municipalityStreetsFiltered = response.data.addresses;
      this.municipalityStreets = response.data.addresses;
    },
    updateCoordinates(coordinates) {
      clearTimeout(this.timer);
      this.timer = setTimeout(
        function () {
          this.location = {
            lat: coordinates.lat(),
            lng: coordinates.lng()
          };
        }.bind(this),
        100
      );
    },
    updateCoordinatesDrag(coordinates) {
      this.location = {
        lat: coordinates.latLng.lat(),
        lng: coordinates.latLng.lng()
      };
    },
    handleDropdownSelected(option) {
      this.communityType = option;
    },
    handleStreetNumberInput() {
      clearTimeout(this.timer);
      this.timer = setTimeout(
        function () {
          this.getLocationCoordinates(
            `${this.selectedAddress.street_name} ${this.streetNumber} ${this.selectedMunicipality.name} ${this.selectedMunicipality.city}`
          );
        }.bind(this),
        150
      );
    },
    handleFileUpload(file) {
      this.uploadedFile = file.file;
    },
    removeData(dataName) {
      if (this[dataName] == null) {
        return;
      }
      this[dataName] = null;
      this.step--;
    },
    getAllMunicipalities() {
      axios
        .post('municipality/get-municipalities-by-name', {
          name: ''
        })
        .then(({ data }) => {
          this.municipalities = data;
          this.municipalitiesFiltered = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStreetsForMunicipality(id = this.municipality.id) {
      axios
        .post('address/get-by-municipality', {
          street_name: '',
          municipality_id: id
        })
        .then(({ data }) => {
          this.municipalityStreets = data.addresses;
          this.municipalityStreetsFiltered = data.addresses;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLocationCoordinates(name) {
      const geoCoder = new google.maps.Geocoder(); /* eslint-disable-line */
      geoCoder.geocode({ address: name }, (results, status) => {
        if (status === 'OK') {
          this.location = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          };
          this.mapCenter = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          };
        }
      });
    },
    saveCommunity() {
      if (this.isLoading || !this.validateInput()) {
        return;
      }
      if (
        !this.selectedAddress ||
        !this.selectedMunicipality ||
        !this.streetNumber
      ) {
        this.showFailModal('Morate popuniti sva polja');
        return;
      }
      this.isLoading = true;
      if (this.uploadedFile == null) {
        this.createNewCommunity();
      } else {
        axios
          .post('/media/add', this.formatMediaForSubmit(), {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then((res) => {
            this.createNewCommunity(res.data.ids[0]);
          })
          .catch((err) => {
            console.log(err);
            this.showFailModal();
            this.isLoading = false;
          });
      }
    },
    createNewCommunity(mediaId = 2) {
      axios
        .post('community/create', {
          community: {
            address: {
              id: this.selectedAddress.id,
              name: this.selectedAddress.street_name,
              municipalityId: this.selectedMunicipality.id
            },
            streetNumber: this.streetNumber,
            city: this.selectedAddress.city,
            location: {
              lat: this.location.lat,
              lng: this.location.lng
            },
            typeOfCommunity: 'vlasnika stanara',
            description: this.communityDescription,
            communityImage: {
              mediaId: mediaId
            }
          },
          member: {
            divDescription: this.member.divDescription,
            votingPoints: this.member.votingPoints,
            isManager: this.member.isManager,
            isCashier: this.member.isCashier,
            status: this.member.status
          }
        })
        .then(async (response) => {
          const newCommunityId = response.data.community_id;
          const res = await axios.get('user/get-communities');
          let communitiesOfManager = res.data.filter(
            (c) => c.is_manager === '1'
          );
          if (communitiesOfManager.length === 0) {
            localStorage.removeItem('k-t');
            this.$router.push('/logout');
            return;
          }
          for (let c of communitiesOfManager) {
            c.notifications = {
              polls: 0,
              tickets: 0,
              members: 0,
              unreadNotificationsCount: 0
            };
          }
          this.setCommunities(communitiesOfManager);
          let data = JSON.parse(localStorage.getItem('k-d'));
          data.communities = communitiesOfManager;
          localStorage.setItem('k-d', JSON.stringify(data));
          let activeCommunityId = newCommunityId;
          var index = communitiesOfManager
            .map(function (e) {
              return e.community_id;
            })
            .indexOf(activeCommunityId);
          if (index === -1 && communitiesOfManager[0]) {
            this.setActiveCommunity(communitiesOfManager[0].community_id);
          } else {
            this.setActiveCommunity(newCommunityId);
            let activeCommunityName =
              this.street.street_name +
              ' ' +
              this.streetNumber +
              ', ' +
              response.data.municipality_name;
            this.$toasted.show(
              `Izabrana zajednica promenjena na: ${activeCommunityName}`
            );
            this.$router.push({
              name: 'communityMembers'
            });
          }

          this.showSuccessModal();
        })
        .catch((err) => {
          console.log(err);
          this.showFailModal();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      fd.append('files[]', this.uploadedFile, this.uploadedFile.name);
      fd.append('type', 'community');
      fd.append('community_id', '');
      return fd;
    },
    validateInput() {
      return !this.checkIfEmpty('streetNumber');
    },
    checkIfEmpty(field) {
      if (this[field] == '' || this[field] == null) {
        this.errorLog[field] = true;
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      addressSearchFocus: false,
      selectedStreet: null,
      municipalitySearchFocus: false,
      selectedMunicipality: null,
      mapCenter: {
        lat: 44.80225560855148,
        lng: 20.446508858257303
      },
      dropdownOptions: [
        'vlasnika stanara',
        'vlasnika garažnih mesta',
        'ostalo'
      ],
      municipalities: [],
      municipalitiesFiltered: [],
      municipalityStreets: [],
      municipalityStreetsFiltered: [],
      step: 1,
      errorLog: {
        municipality: false,
        street: false,
        streetNumber: false,
        otherType: false,
        communityDescription: false
      },

      municipality: null,
      street: null,
      streetNumber: '',
      communityType: '',
      otherType: '',
      communityDescription: '',
      location: {
        lat: 44.7992105,
        lng: 20.342356
      },
      uploadedFile: null,

      timer: null,
      isLoading: false,

      member: {
        divDescription: 'Admin',
        votingPoints: 0,
        isManager: 1,
        isCashier: 0,
        status: 1
      }
    };
  },
  computed: {
    getZoomLevel() {
      switch (this.step) {
        case 1:
          return 12;
        case 2:
          return 14;
        case 3:
          return 16;
        case 4:
          return 17;
        default:
          return 10;
      }
    },
    isValidated() {
      return this.validateInput();
    }
  },
  watch: {
    // municipality: function(data) {
    //   if (data.manual) {
    //     return;
    //   }
    //   if (data.id) {
    //     data = {
    //       text: data.name,
    //       value: data
    //     };
    //     this.municipality = data;
    //   }
    //   this.handleMunicipalitySelection(data);
    // }
  }
};
</script>

<style lang="scss">
.new-community {
  width: 100%;
  height: 100vh;
  display: flex;
  .address-search {
    height: calc(2.25rem + 5px) !important;
    input {
      font-size: 1rem !important;
    }
    item {
      font-size: 1rem !important;
    }
  }
  .data__img-input-wrapper {
    margin-bottom: 32px;
  }
  .data {
    flex: 1;
    padding: 2rem 1rem;
    font-size: 1.7rem;
    &__header {
      text-align: center;
      color: var(--primary-color);
      margin-bottom: 3rem;
    }

    &__img-input-wrapper {
      display: inline-flex;
      justify-content: space-between;
      width: 100%;
    }
  }

  .map {
    flex: 2;
    position: relative;

    &__marker {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -60px;
      margin-left: -30px;
    }
  }

  .pac-container {
    .pac-item:hover {
      background-color: var(--grey-lighten);
      cursor: pointer;
    }
  }
  .pac-container::after {
    display: none;
  }

  .input-wrapper {
    display: flex;
    width: 100%;
    position: relative;
    .user--mod {
      width: 100%;
      margin-bottom: 2rem;
      input {
        margin-bottom: 0;
      }
      .ui.fluid.search {
        width: 100%;
        line-height: 1.5;
        border-radius: 0.3rem;
        border: 1px solid #ced4da;
        font-size: 1rem;
        color: inherit;
        transition: 0.2s all;
        height: calc(2.25rem + 2px);

        input {
          border: none;
          padding: 0.5rem 1rem;
          font-size: 1rem;
          line-height: 1;
          max-width: 100%;
        }

        input:focus {
          border: none;
          outline: none;
          & {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .text {
          position: absolute;
          top: 7px;
          left: 1rem;
          color: inherit;
          font-size: 1rem;
        }
        .menu {
          border: 1px solid #ced4da;
          border-radius: 0.3rem;
          border-top-width: 0;
          border-top-right-radius: 0;
          border-top-left-radius: 0;
          z-index: 11;
          background-color: white;
          max-height: 10rem;
          overflow-y: auto;
          margin: -5px -1px 0px -1px;
          .item {
            z-index: 15;
          }
          .item:hover {
            background-color: rgba(0, 0, 0, 0.05);
            cursor: pointer;
          }

          .item.selected {
            background-color: rgba(0, 0, 0, 0.178);
          }

          .btn--add {
            width: 100%;
          }
        }
      }
    }
    .add-member-dropdown {
      .menu {
        max-height: 10rem !important;
      }
    }

    .amount--mod {
      width: 100%;
      margin-bottom: 2rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .relative {
      position: relative;
    }
  }

  .body {
    height: 100%;
    width: 100%;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  .btn-add-desc {
    i {
      margin-left: 4px;
    }
  }

  .desc-wrapper {
    display: flex;
    justify-content: space-between;
    span {
      margin-bottom: 9px;
      margin-left: 8px;
      min-width: 60px;
    }
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .mandatory {
    color: red;
  }

  label.tooltip-label {
    display: flex;
    .mandatory {
      margin-left: 4px;
    }
    .popover {
      position: relative;
      width: fit-content;
      border: none;
      padding: 4px 4px 2px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 1.1rem;
        color: var(--primary-color);
      }
    }
  }
}
</style>
